import { createContext, useContext, useEffect, useState } from 'react';
import { api, formatApiError, getToken, setToken } from '@/lib/api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);    // null = checking | false = anon | object = signed in
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const token = getToken();
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get('/auth/me')
      .then((r) => mounted && setUser(r.data))
      .catch(() => {
        setToken(null);
        if (mounted) setUser(false);
      })
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  async function login(email, password) {
    try {
      const { data } = await api.post('/auth/login', { email, password });
      setToken(data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  }

  function logout() {
    setToken(null);
    setUser(false);
  }

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout }}>{children}</AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
